import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatRateName',
  standalone: true
})

export class formatRateNamePipe implements PipeTransform {

  transform(rate: any): string {
    const pimRateName = rate?.rate?.pim?.rateName?.trim();
    const rateName = rate?.rate?.rateName?.trim();
    const rateNamePms = rate?.rate?.rateNamePms;

    if (pimRateName) {
      return pimRateName;
    } else if (rateName) {
      return rateName;
    } else {
      return rateNamePms || '';
    }
  }
}